/**
 * @voltxampere/shared — System error leaf classes
 *
 * Covers SPECS §5.2 rows 24–27 (the `system` category). These are
 * infrastructure and invariant failures — not anything the end
 * user can fix. `E_INTERNAL` and `E_CONTRACT` are `fatal` and
 * non-recoverable: they mean VXA itself reached an impossible
 * state, and the correct response is to surface a report-issue CTA.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { SystemError } from "./categories.js";
export class InternalError extends SystemError {
    code = "E_INTERNAL";
    recoverable = false;
    defaultSeverity() {
        return "fatal";
    }
}
export class ContractViolationError extends SystemError {
    code = "E_CONTRACT";
    recoverable = false;
    defaultSeverity() {
        return "fatal";
    }
}
export class WorkerCrashError extends SystemError {
    code = "E_WORKER_CRASH";
    recoverable = true;
    defaultSeverity() {
        return "error";
    }
}
export class NetworkError extends SystemError {
    code = "E_NETWORK";
    recoverable = true;
    defaultSeverity() {
        return "warning";
    }
}
//# sourceMappingURL=system-errors.js.map